import Box from "@mui/material/Box"
import {useNavigate} from "react-router-dom"
import cristalinaLogo from "../../assets/cristalina_logo.svg"
import styles from "./home.module.scss"

const tiles = [
    {
        icon: "⌖",
        title: "Ops site visit",
        description: "Check in at site, log updates and photos",
        path: "/site-visit",
    },
    {
        icon: "⚡",
        title: "Digital commissioning form",
        description: "Technician charger commissioning at site",
        path: "/commissioning-form",
    },
    {
        icon: "📋",
        title: "Survey Commissioning",
        description: "Complete charger commissioning survey at site",
        path: "/site-survey",
    },
]

const commissioningDisabled = process.env.REACT_APP_DISABLE_COMMISSIONING === "true"

const Home = () => {
    const navigate = useNavigate()

    return (
        <Box className={styles.land_wrapper}>
            <Box className={styles.land}>
                <Box className={styles.land__bg}></Box>
                <Box className={styles.land__brandlogo}>
                    <img src={cristalinaLogo} alt="Cristalina" />
                </Box>
                <h1 className={styles.land__heading}>
                    Field tools,
                    <br />
                    in one <em>place</em>.
                </h1>
                <p className={styles.land__tagline}>
                    Pick what you&apos;re here to do. Everything you submit lands directly on the ticket in Cristalina.
                </p>
                <Box className={styles.land__tiles}>
                    {tiles.map(tile => (
                        <button
                            key={tile.path}
                            className={styles.land__tile}
                            disabled={tile.path === "/commissioning-form" && commissioningDisabled}
                            onClick={() => navigate(tile.path)}>
                            <span className={styles.land__tile__icon}>{tile.icon}</span>
                            <span className={styles.land__tile__text}>
                                <b>{tile.title}</b>
                                <em>{tile.description}</em>
                            </span>
                            <span className={styles.land__tile__arrow}>›</span>
                        </button>
                    ))}
                </Box>
                <small className={styles.land__footer}>Statiq Operations · v1.0</small>
            </Box>
        </Box>
    )
}

export default Home
